// Create initial state
export const state = {
  darkMode: false
}

// Declare state
export type State = typeof state;
